export const Types = {
  FETCH_MAINTENANCE_REQUEST: "maintenance/fetch_request",
  FETCH_MAINTENANCE_SUCCESS: "maintenance/fetch_success",
  FETCH_MAINTENANCE_FAILURE: "maintenance/fetch_failure",
  DISMISS_MAINTENANCE_BANNER: "maintenance/dismiss_banner",
  LOAD_DISMISSED_BANNERS: "maintenance/load_dismissed_banners",
};

export const fetchMaintenanceRequest = () => ({
  type: Types.FETCH_MAINTENANCE_REQUEST,
});

export const fetchMaintenanceSuccess = (payload) => ({
  type: Types.FETCH_MAINTENANCE_SUCCESS,
  payload,
});

export const fetchMaintenanceFailure = (error) => ({
  type: Types.FETCH_MAINTENANCE_FAILURE,
  error,
});

export const dismissMaintenanceBanner = (bannerId) => ({
  type: Types.DISMISS_MAINTENANCE_BANNER,
  payload: bannerId,
});

export const loadDismissedBanners = () => ({
  type: Types.LOAD_DISMISSED_BANNERS,
});
